module.exports = __webpack_public_path__ + "static/media/download_img_1.1637ab87.jpg";